import PropTypes from "prop-types";
import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import styled from "styled-components/macro";

import FnrLoadingCarousel from "UI/FnrLoadingCarousel";

import Portal from "Utilities/PortalMaker";
import { usePortalElement } from "Utilities/PortalMaker/usePortalElement";

import API from "./API";
import { BoardContext } from "./BoardContext";
import Table from "./Table";
import { BOARD_TYPES } from "./const";

Board.propTypes = {
  boardURL: PropTypes.string,
  groupURL: PropTypes.string,
};

export default function Board({ boardURL, groupURL }) {
  const history = useHistory();
  const [state, dispatch] = useContext(BoardContext);
  const [loaded, setLoaded] = useState(false);
  const [title, setTitle] = useState();

  const portalToElement = usePortalElement(".group_content", 1000);

  useEffect(
    function updateURLsInContext() {
      if (state.boardURL !== boardURL || state.groupURL !== groupURL) {
        dispatch({ type: "Update URLs", boardURL, groupURL });
      }
    },
    [groupURL, boardURL, state, dispatch]
  );

  // load filter panel assets
  useEffect(() => {
    window.fnReactBus.loadSheetsResources();
  }, []);

  useEffect(() => {
    setLoaded(false);
    setTitle(null);
    dispatch({ type: "clearBoardData" });

    const getBoardCall = API.getGroupBoard({
      groupURL,
      boardURL,
      bypassSavedBoardFilter: false,
    });

    getBoardCall
      .post()
      .then((boardData) => {
        if (boardData?.boardInfo?.url !== boardURL) return;
        dispatch({ type: "setBoardType", payload: BOARD_TYPES.GROUP });
        dispatch({ type: "setBoardData", payload: boardData });
        dispatch({
          type: "Update filteredTotal",
          payload: boardData?.filteredTotal,
        });
        dispatch({
          type: "Update unfilteredTotal",
          payload: boardData?.unfilteredTotal,
        });
        setTitle(boardData?.boardInfo?.title);
        dispatch({ type: "Set shouldUseSavedBoardFilter", payload: false });

        setLoaded(true);
      })
      .catch(() => {
        const peopleUrl = `/${groupURL}/people`;
        history.push(peopleUrl);
        if (window.fnReactBus?.goToUrl) {
          window.fnReactBus.goToUrl(peopleUrl);
        }
      });

    return () => {
      window.fnReactBus.removeFiltersPanelObj();
      dispatch({ type: "Filter Panel Closed" });
      getBoardCall?.cancel();
    };

    // Aug 2021 → we’re doing a clean slate of all eslint warnings- this is disabled because we don't have time to look at it.
    // eslint-disable-next-line
  }, [groupURL, boardURL, dispatch]);

  if (!portalToElement) return null;

  return (
    <Portal to={portalToElement}>
      <Wrapper
        className="page group_panel page_sheet on"
        data-cy="Board_Container"
      >
        {!loaded ? <FnrLoadingCarousel show={true} /> : <Table />}
      </Wrapper>
    </Portal>
  );
}

const Wrapper = styled.div`
  top: 0;
  bottom: 0;
  background: #fff;
`;
